import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { DiscoDetailsModule, DiscoFormModule, DynamicReportsModule } from '@app/discoverer/dynamic-reports';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { IntlModule } from '@progress/kendo-angular-intl';
import 'hammerjs';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicTableComponent } from './custom-components/home-table/home-table.component';
import { AggregatedTableComponent } from './custom-components/aggregated-table/aggregated-table.component';
import { DynamicChartComponent } from './custom-components/home-chart/home-chart.component';
@NgModule({
    declarations: [
        DynamicTableComponent,
        AggregatedTableComponent,
        DynamicChartComponent
    ],

    imports: [
        CommonModule,
        RouterModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        FormsModule,
        MatMenuModule,
        MatListModule,
        DynamicReportsModule,
        ReactiveFormsModule,
        DiscoDetailsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatButtonModule,
        DiscoFormModule,
        MatOptionModule,
        ChartsModule,
        IntlModule,
    ],
    exports: [
        DynamicTableComponent,
        AggregatedTableComponent,
        DynamicChartComponent
    ]
})
export class CustomComponentsModule {
}
